import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ScheduledPaymentModel } from '../../models';
import { FormInputChangedModel } from '../../../shared/models';
import { CurrencyModel } from '../../../payment/models/currency.model';
import { selectCurrencies } from '../../store/selectors';
import { AppState } from '../../../store/state/app.state';

@Component({
  selector: 'rnpl-scheduled-payment-properties',
  templateUrl: './scheduled-payment-properties.component.html',
})
export class ScheduledPaymentPropertiesComponent {

  @Input() readonly scheduledPayment: ScheduledPaymentModel;
  @Input() readonly form: FormGroup;
  @Input() readonly isView: boolean;
  @Input() readonly workspaceCurrency: string;

  public currencies$: Observable<CurrencyModel[]> = this.store.select(selectCurrencies);

  @Output() fieldChanged: EventEmitter<FormInputChangedModel> = new EventEmitter<FormInputChangedModel>();

  constructor(
    private readonly store: Store<AppState>,
  ) {
  }

  public updateField(fieldValue: any, fieldName: string): void {
    this.fieldChanged.emit({fieldName, fieldValue});
  }

  get currency(): FormControl { return this.form.get('properties').get('currency') as FormControl; }
  get exchangeRate(): FormControl { return this.form.get('properties').get('exchangeRate') as FormControl; }

}
